(ns buzz-bot.db)

(def default-db
  {:view        :inbox
   :view-params {}
   :init-data   ""
   :theme       {}
   :inbox       {:episodes [] :loading? false :search-query ""
                 :filters  {:hide-listened? false :compact? false :excluded-feeds #{}}}
   :inbox-dubbed {:items    []
                  :loading? false
                  :loaded?  false}
   :dubbed       {:items [] :languages [] :loading? false :loaded? false}
   ;; Persisted language filter (set of lowercase codes) shared by the Dubbed
   ;; page and the inbox bar. Empty set = all languages.
   :dubbed-filter {:langs (if (exists? js/localStorage)
                            (let [raw (or (.getItem js/localStorage "buzz-dubbed-langs") "")]
                              (into #{} (remove empty? (.split raw ","))))
                            #{})}
   :feeds       {:list [] :loading? false}
   :episodes    {:feed-id          nil
                 :list             []
                 :offset           0
                 :has-more?        false
                 :order            :desc
                 :loading?         false
                 ;; NEW — delivery feature
                 :delivery-mode    :off
                 :new-episode-ids  #{}
                 :delivery-pending nil
                 :delivery-upsell? false
                 :is-premium?      false}
   :player      {:data nil :loading? false :send-status nil}
   :bookmarks   {:list [] :loading? false :query ""}
   :topics    {:tags [] :episodes [] :loading? false :selected-tag nil :has-more-tags? false :tag-offset 0
               :cloud-hint-dismissed? (and (exists? js/localStorage)
                                           (= "1" (.getItem js/localStorage "topics-cloud-hint-dismissed")))}
   :search      {:query "" :results [] :loading? false :subscribed-urls #{}}
   :audio       {:episode-id nil :title "" :artist "" :artwork ""
                 :src "" :playing? false :current-time 0 :duration 0
                 :rate 1 :autoplay? false :pending? false}
   :saved-list  {:view nil :count 0}
:dub {:statuses   {}    ;; lang-code → {:status :done/:pending/:processing/:failed/:expired :r2-url nil :translation nil :error nil}
         :active-lang nil} ;; currently playing dubbed language (nil = original)
   :subtitles {:ep-id nil
               :cues  []
               :lang  :off}
   :offline {:cached-ids      []   ;; episode IDs, most-recent-first, max 5
             :in-progress     {}   ;; ep-id → {:bytes-downloaded N :bytes-total N}
             :network-online? true}
   :flags   {}})  ;; feature flag name → bool, loaded from /flags on init
